import { createDataHooks } from '@wix/premium-fed-sdk/test-utils';

export const CYCLE_SELECTOR_DATA_HOOKS = createDataHooks(
  'cycle-selector',
  'item',
  'item-name',
  'item-name-tooltip',
  'badge',
  'badge-tooltip',
);
